// Geliştirmede API'yi React sunucusu üzerinden aynı origin'den çağır. Böylece
// tarayıcının localhost/IPv4/CORS farklarından etkilenmeden backend'e ulaşılır.
const useDevelopmentProxy = process.env.NODE_ENV === 'development' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const API_BASE_URL = process.env.REACT_APP_API_URL || (useDevelopmentProxy ? '/api' : 'http://localhost:5105/api');

export const resolveMediaUrl = (value) => {
  if (!value) return '';
  if (/^(https?:|data:|blob:)/i.test(value)) return value;
  const path = value.startsWith('/') ? value : `/${value}`;
  const configuredBase = (process.env.REACT_APP_QUESTIONS_MEDIA_URL || '').replace(/\/$/, '');
  return configuredBase ? `${configuredBase}${path}` : path;
};

const TOKEN_KEY = 'token';
const USER_KEY = 'user';
const STORAGE_MIGRATION_KEY = 'examSessionStorageV1';

// Eski kalıcı oturumları yalnızca bir kez temizle. Bundan sonra oturum, tarayıcı
// kapatıldığında otomatik silinen sessionStorage'da tutulur.
const removeLegacyPersistentSession = () => {
  if (sessionStorage.getItem(STORAGE_MIGRATION_KEY)) return;

  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  sessionStorage.setItem(STORAGE_MIGRATION_KEY, '1');
};

const clearSession = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
};

const isExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return typeof payload.exp === 'number' && payload.exp * 1000 <= Date.now();
  } catch {
    return true;
  }
};

// Token tarayıcı sekmesi oturumu boyunca saklanır. Süresi dolmuş veya bozuk bir
// token ilk uygulama yüklenişinde temizlenir; imza doğrulaması backend'de yapılır.
export const getToken = () => {
  removeLegacyPersistentSession();
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (token && isExpired(token)) {
    clearSession();
    return null;
  }
  return token;
};

export const setToken = (token) => {
  removeLegacyPersistentSession();
  if (token) {
    sessionStorage.setItem(TOKEN_KEY, token);
  } else {
    sessionStorage.removeItem(TOKEN_KEY);
  }
};

// User bilgisi token ile aynı, tarayıcıya bağlı oturum alanında tutulur.
export const getUser = () => {
  removeLegacyPersistentSession();
  const userStr = sessionStorage.getItem(USER_KEY);
  if (userStr) {
    try {
      return JSON.parse(userStr);
    } catch (e) {
      return null;
    }
  }
  return null;
};

export const setUser = (user) => {
  removeLegacyPersistentSession();
  if (user) {
    sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  } else {
    sessionStorage.removeItem(USER_KEY);
  }
};

// Token ile fetch wrapper
export const apiFetch = async (url, options = {}) => {
  const token = getToken();
  
  const headers = {
    ...options.headers,
  };
  
  // FormData ise Content-Type ekleme (browser otomatik ekler)
  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const response = await fetch(`${API_BASE_URL}${url}`, {
    ...options,
    headers,
  });
  
  // Token geçersizse logout
  if (response.status === 401) {
    setToken(null);
    setUser(null);
    // Sayfayı yenile ki App.js login'e yönlendirsin
    window.location.reload();
  }
  
  return response;
};
